import type { RatingAccountQuery } from "lib/generated/graphql"
import { createContext } from "react"

interface ContextType {
  accountTitle?: NonNullable<RatingAccountQuery["rating"]>["accountTitle"]
}

export const Context = createContext<ContextType>({})
